/* React */
import React, { useState, useEffect, useContext } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import * as bcrypt from "bcryptjs";

/* Componentes y dependencias */
import { Typography } from "@mui/material";
import Preloader from "../../utils/Preloader";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import { AuthContext } from "../../../context/AuthContext";
import jsPDF from "jspdf";
import "jspdf-autotable";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

import styles from "../layout.module.css";

import PagoDetalles from "./PagoDetalles";
//import ExportExcel from "react-export-excel";

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  CircularProgress,
  Grid,
} from "@mui/material";

/* Servicios */
import PagoService from "../../../services/Pago.service";
import PaqueteService from "../../../services/Paquete.service";

const Corte = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const { currentUser } = useContext(AuthContext);
  const [paquete, setPaquete] = useState(0);

  const [total, setTotal] = useState(0);
  const [pagos, setPagos] = useState([]);
  const [totalPagos, setTotalPagos] = useState(0);
  const [pagosEnProceso, setPagosEnProceso] = useState(0);
  const [pagosConfirmado, setConfirmado] = useState(0);
  const [pagosCancelado, setPagosCancelado] = useState(0);

  const [totalPagosCantidad, setTotalPagosCant] = useState(0);
  const [pagosEnProcesoCantidad, setPagosEnProcesoCant] = useState(0);
  const [pagosConfirmadoCantidad, setConfirmadoCant] = useState(0);
  const [pagosCanceladoCantidad, setPagosCanceladoCant] = useState(0);

  const navigate = useNavigate();

  const [tabla, setTabla] = useState([]);
  const fecha = new Date();
  const fechaD = String(fecha.getDate());
  const fechaM = String(fecha.getMonth());
  const fechaY = String(fecha.getFullYear());

  const [open, setOpen] = useState(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 550,
    bgcolor: "background.paper",
    border: "0px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    getProductos();
    getPagos();
  }, []);

  const getProductos = async () => {
    setLoading(true);
    try {
      const data = await PaqueteService.getAll();
      setTotal(data.length);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const getPagos = async () => {
    setLoading(true);
    try {
      console.log("pagos de id: " + id);
      const totalpagos = await PagoService.findPagosByPaquete(id);
      const paque = await PaqueteService.getById(id);
      setPaquete(paque);

      let conf = 0;
      let cancel = 0;
      let proces = 0;
      let confCant = 0;
      let cancelCant = 0;
      let procesCant = 0;

      console.log("total de pagos: " + totalpagos.data.length);

      totalpagos.data.forEach((record) => {
        console.log("------");
        if (record.status == "EnProceso") {
          proces += 1;
          procesCant = Number(procesCant) + Number(record.precio);
        }
        if (record.status == "Cancelado") {
          cancel += 1;
          cancelCant = Number(cancelCant) + Number(record.precio);
        }
        if (record.status == "Confirmado") {
          conf += 1;
          confCant = Number(confCant) + Number(record.precio);
        }
      });
      console.log("------");
      console.log("confirmado: " + conf);
      console.log("cancelado: " + cancel);
      console.log("En proceso: " + proces);

      setPagosCancelado(cancel);
      setPagosEnProceso(proces);
      setConfirmado(conf);

      setPagosEnProcesoCant(procesCant);
      setPagosCanceladoCant(cancelCant);
      setConfirmadoCant(confCant);

      setPagos(totalpagos.data);
      setTotalPagos(totalpagos.data);
      let t = Number(procesCant) + Number(cancelCant) + Number(confCant);
      setTotalPagosCant(t);

      /*
      let totalPagosCant = 0;
      console.log("-------" + totalpagos.data.length);
      totalpagos.data.forEach((pago) => {
        totalPagosCant += parseInt(pago.precio);
      });
      const newFila = {
        titulo: "Total de ventas",
        cantidad: totalpagos.total,
        total: "$" + totalPagosCant,
      };
      setTabla((tabla) => [...tabla, newFila]);
      console.log("---total Pagos" + totalPagosCant);
      setTotalPagosCant(totalPagosCant);

      const enproceso = await PagoService.countPagosByStatus("EnProceso");
      //setPagosEnProceso(enproceso.total);
      let totalEnProcesoCant = 0;
      enproceso.data.forEach((pago) => {
        totalEnProcesoCant += parseInt(pago.precio);
      });
      const newFila2 = {
        titulo: "Ventas en proceso",
        cantidad: enproceso.total,
        total: "$" + totalEnProcesoCant,
      };
      setTabla((tabla) => [...tabla, newFila2]);
      console.log("---total en proceso" + totalEnProcesoCant);
      //setPagosEnProcesoCant(totalEnProcesoCant);

      const terminado = await PagoService.countPagosByStatus("Confirmado");
      //setConfirmado(terminado.total);
      let totalTerminadoCant = 0;
      terminado.data.forEach((pago) => {
        totalTerminadoCant += parseInt(pago.precio);
      });
      const newFila3 = {
        titulo: "Ventas terminadas",
        cantidad: terminado.total,
        total: "$" + totalTerminadoCant,
      };
      setTabla((tabla) => [...tabla, newFila3]);
      //setTerminadoCant(totalTerminadoCant);

      const cancelado = await PagoService.countPagosByStatus("Cancelado");
      //setPagosCancelado(cancelado.total);
      let totalCanceladoCant = 0;
      cancelado.data.forEach((pago) => {
        totalCanceladoCant += parseInt(pago.precio);
      });
      const newFila4 = {
        titulo: "Ventas canceladas",
        cantidad: cancelado.total,
        total: "$" + String(totalCanceladoCant),
      };
      setTabla((tabla) => [...tabla, newFila4]);*/
      //setPagosCanceladoCant(totalCanceladoCant);
    } catch (error) {
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };

  const img =
    "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAXwBfAAD/2wBDAAoHBwkHBgoJCAkLCwoMDxkQDw4ODx4WFxIZJCAmJSMgIyIoLTkwKCo2KyIjMkQyNjs9QEBAJjBGS0U+Sjk/QD3/2wBDAQsLCw8NDx0QEB09KSMpPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT3/wgARCAAaABQDAREAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAABQYAAwQB/8QAGAEBAQEBAQAAAAAAAAAAAAAAAwEAAgT/2gAMAwEAAhADEAAAAXKbOK1c92KOHzuQcxaHNjdidpy5yl//xAAfEAACAQMFAQAAAAAAAAAAAAABAgADEhMEEBEhIjH/2gAIAQEAAQUC+QuVq6duEqnoephWKDia/FLjLjt//8QAHREAAgIBBQAAAAAAAAAAAAAAAAIBEQMSEyAiMf/aAAgBAwEBPwEhIZLj2DOttcCkNp7G8xZfH//EAB4RAAIDAAEFAAAAAAAAAAAAAAABAgMREiAhIjFR/9oACAECAQE/AR2ONmS9MolkcZZ8aHDl4b2FTEaEun//xAAhEAABAwMEAwAAAAAAAAAAAAABAAIRAxAxEjJBQiFhYv/aAAgBAQAGPwJQ7acIg8FQWFzfS0B0t+shcpkNqHx1KqahU29rZKybf//EAB0QAQADAQACAwAAAAAAAAAAAAEAESExQVFhgZH/2gAIAQEAAT8hUFrUE1U6+ZZvXITcrvpNdp4xEO+l1b7Gv7BQdYMALdXDkpwD7ipT+kOT/9oADAMBAAIAAwAAABBnmCSOz//EABsRAQACAwEBAAAAAAAAAAAAAAEAESExYSBx/9oACAEDAQE/EAXUQdz5KIsIMuNjTLWFPNMVwaOQoRsVXn//xAAcEQEAAgIDAQAAAAAAAAAAAAABABEhMSBhcVH/2gAIAQIBAT8QUMsIdQ9/JZNpSUTIImK3bZ5AbtfZa3cpbvj/AP/EABwQAQACAwEBAQAAAAAAAAAAAAEAESExQXFRwf/aAAgBAQABPxCsIatahd4Y+dDAb93fjD4HtO4qLlXU0ej2pdETsO11xEdV8cP2hExkSA2d3NHkA0Q0CIxSEyKmjyf/2Q==";
  const imag =
    "data:image/png;base64,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";

  const imagChimalli =
    "data:image/png;base64,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";

  const pdf = () => {
    const pdf = new jsPDF();
    pdf.setFontSize(18);
    pdf.text(paquete.titulo, 14, 22);
    pdf.setFontSize(11);
    pdf.setTextColor(100);
    var pageSize = pdf.internal.pageSize;
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
    var Text = pdf.splitTextToSize(
      "Día: " + fechaD + "/" + fechaM + "/" + fechaY,
      pageWidth - 35,
      {}
    );
    pdf.text(Text, 14, 30);
    //pdf.addImage(imagChimalli, "PNG", 130, 15, 65, 18);
    pdf.autoTable({ startY: 50, html: "#tablaCorte" });
    pdf.autoTable({ startY: 100, html: "#tablaCorte2" });
    pdf.save("corte.pdf");
  };

  const EliminarPagos = async () => {
    try {
      const validPass = await bcrypt.compare(
        password.password,
        currentUser.contraseña
      );
      if (validPass) {
        toast.success("Corte realizado");
        const corte = await PagoService.Corte(id);
        
      } else {
        toast.error("Contraseña incorrecta");
      }
    } catch {
    } finally {
      handleClose();
      //navigate("/pagos");
    }
  };

  return (
    <>
      {loading ? (
        <Preloader />
      ) : (
        <>
          <div className={styles.recentorders}>
            <div style={{ overflowX: "auto" }}>
              <div style={{ display: "flex" }}>
                <div style={{ width: "70%" }}>
                  <table className="table" id="tablaCorte">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          style={{ textAlign: "left", width: "50%" }}
                        >
                          <h1
                            style={{
                              marginRight: "20px",
                              marginBottom: "20px",
                            }}
                          >
                            RESERVAS
                          </h1>
                        </th>
                        <th scope="col"></th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th
                          scope="col"
                          style={{ textAlign: "left", padding: "2%" }}
                        >
                          Paquetes
                        </th>
                        <th scope="col">{paquete.titulo}</th>
                        <th scope="col">-</th>
                      </tr>

                      <tr>
                        <th
                          scope="col"
                          style={{ textAlign: "left", padding: "2%" }}
                        >
                          Reservas confirmadas
                        </th>
                        <th scope="col">{pagosConfirmado}</th>
                        <th scope="col">${pagosConfirmadoCantidad}</th>
                      </tr>

                      <tr>
                        <th
                          scope="col"
                          style={{ textAlign: "left", padding: "2%" }}
                        >
                          Reservasd en proceso
                        </th>
                        <th scope="col">{pagosEnProceso}</th>
                        <th scope="col">${pagosEnProcesoCantidad}</th>
                      </tr>

                      <tr>
                        <th
                          scope="col"
                          style={{ textAlign: "left", padding: "2%" }}
                        >
                          Reservas canceladas
                        </th>
                        <th scope="col">{pagosCancelado}</th>
                        <th scope="col">${pagosCanceladoCantidad}</th>
                      </tr>

                      <tr>
                        <th
                          scope="col"
                          style={{ textAlign: "left", padding: "2%" }}
                        >
                          Total de reservas
                        </th>
                        <th scope="col">{totalPagos.length}</th>
                        <th scope="col">${totalPagosCantidad}</th>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div style={{ width: "30%", paddingLeft: "5%" }}>
                  <table style={{ paddingTop: "30%", paddingBottom: "50%" }}>
                    <tbody
                      style={{
                        textAlign: "center",
                        alignItems: "center",
                        alignContent: "center",
                      }}
                    >
                      <th>
                        <tr>
                          <Button
                            variant="outlined"
                            style={{
                              marginLeft: "50%",
                              width: "120%",
                              marginTop: "10%",
                            }}
                            color="error"
                            onClick={() => {
                              navigate("/pagos");
                            }}
                          >
                            CANCELAR
                          </Button>
                        </tr>
                        <tr>
                          <Button
                            variant="contained"
                            style={{
                              marginLeft: "50%",
                              width: "120%",
                              marginTop: "10%",
                            }}
                            color="error"
                            onClick={() => {
                              pdf();
                            }}
                          >
                            PDF <FileOpenIcon style={{ marginLeft: "30%" }} />
                          </Button>
                        </tr>
                        <tr
                          style={{
                            textAlign: "center",
                            alignItems: "center",
                            padding: "15%",
                          }}
                        >
                          <Button
                            variant="contained"
                            style={{
                              marginLeft: "50%",
                              width: "120%",
                              marginTop: "10%",
                            }}
                            color="primary"
                            onClick={() => {
                              handleOpen();
                            }}
                          >
                            TERMINAR
                          </Button>
                        </tr>
                      </th>
                    </tbody>
                  </table>
                </div>
              </div>

              <div>
                <div style={{ width: "100%", marginTop: "5%" }}>
                  <table className="table" id="tablaCorte2">
                    <thead>
                      <tr>
                        <td style={{ fontWeight: "bold" }}>PAYPAL ID</td>
                        <td style={{ fontWeight: "bold" }}>NOMBRE</td>
                        <td style={{ fontWeight: "bold" }}>PAGO</td>
                        <td style={{ fontWeight: "bold" }}>RESERVAS</td>
                        <td style={{ fontWeight: "bold" }}>STATUS</td>
                      </tr>
                    </thead>
                    <tbody>
                      {pagos.map((record) => {
                        return (
                          <tr>
                            <td style={{ fontWeight: "bold" }}>
                              {record.paypal_id}
                            </td>
                            <td style={{ fontWeight: "bold" }}>
                              {record.usuario.nombre} {record.usuario.apellido}
                            </td>
                            <td style={{ fontWeight: "bold" }}>
                              {record.precio}
                            </td>
                            <td style={{ fontWeight: "bold" }}>
                              Adultos: {record.paquete.adulto}, Extras:{" "}
                              {record.paquete.extra}, Niños:{" "}
                              {record.paquete.nino}
                            </td>
                            <td style={{ fontWeight: "bold" }}>
                              {record.status}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  CORTE
                </Typography>
                <Typography>
                  Si continua se eliminaran todas las reservas del paquete{" "}
                  {paquete.titulo}.
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  <table className="table">
                    <tbody>
                      <tr>
                        <th>Contraseña</th>
                        <th>
                          <input
                            onChange={(e) =>
                              setPassword({
                                ...password,
                                password: e.target.value,
                              })
                            }
                            value={password.password}
                            className={`form-control`}
                            type="password"
                            style={{
                              width: "-webkit-fill-available",
                              backgroundColor: "#dce1eb",
                              padding: "2%",
                              marginLeft: "-1%",
                              width: "90%",
                            }}
                          />
                        </th>
                        <th>
                          <Button
                            variant="outlined"
                            color="success"
                            onClick={() => EliminarPagos()}
                          >
                            Corte
                          </Button>
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </Box>
            </Modal>
          </div>
        </>
      )}
    </>
  );
};

export default Corte;
